import { DettaglioEsito } from './dettaglio-esito';
import { DocumentoAllegato } from './documento-allegato';
import { EsitoPerSocieta } from './esito-per-societa';
import { Liquidato } from './liquidato';
import { SoggettoPratica } from './tipologiche/soggetto-pratica';
import { TipoEsito } from './tipologiche/tipo-esito';

export class Esito {
  id: string;
  tipoEsito: TipoEsito;
  documenti: DocumentoAllegato[];
  esitoPerSocieta: EsitoPerSocieta;
  //controparti: Controparte[];
  //classificazioni: Classificazione[];
  numeroEsito: string;
  numeroProtocollo: string;
  definitivo: boolean;
  annoEsito: string;
  societa?: SoggettoPratica;
  dataDeposito: number;
  dataNotifica: number;
  dataImpugnazione: number;
  dataPubblicazione: number;
  dataIrrevocabilita: number;
  note: string;
  provenienza: string;
  liquidati: Liquidato[];
  dettagliEsito: DettaglioEsito[];
  dataTrasmissioneSentenza:Date;
  dataComunicazione:Date;
  dataPronuncia:Date;
  flagCondannaInSolido:boolean;
  flagRivalsa:boolean;
}
